import React, { useState, useEffect, useContext } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { OrderContext } from '../../contexts/OrderContext';
import { getAvailableDates } from '../../services/api';
import { showToast } from '../../utils/utils';

function ScheduleCalendar() {
  const { date, setDate, setStage } = useContext(OrderContext);
  const [holidays, setHolidays] = useState([]);
  const [cutoffTime, setCutoffTime] = useState(null);

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const { upcoming_holidays, cutoff_time } = await getAvailableDates();
        const holidayDates = upcoming_holidays.map(holiday => new Date(holiday));
        
        if (cutoff_time) {
          var now = new Date();
          var nowDateTime = now.toISOString();
          var nowDate = nowDateTime.split('T')[0];
          var target = new Date(nowDate + 'T' + cutoff_time);
          setCutoffTime(target);
        }
        setHolidays(holidayDates);
      } catch (error) {
        console.error('Error fetching holidays:', error);
      }
    };

    fetchHolidays();
  }, []);

  const handleDateChange = (date) => {
    setDate(date);
  };

  const isDateDisabled = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const now = new Date();
    now.setSeconds(0, 0);

    if (date < today) {
      return true;
    }

    if (date.getDay() === 0) {
      return true;
    }

    if (cutoffTime && date.getTime() === today.getTime()) {
      return now.getTime() > cutoffTime.getTime();
    }

    const isHoliday = holidays.some(holiday => {
      const holidayDate = new Date(holiday);
      holidayDate.setHours(0, 0, 0, 0);
      return holidayDate.getTime() === date.getTime();
    });

    return isHoliday;
  };

  const handleDateConfirmation = () => {
    if (date) setStage(2);
    else showToast('error', 'Tienes que seleccionar una fecha');
  }

  return (
    <div className="cart-confirmation">
      <div className="cart-confirmation-header">
        <span className="material-symbols-outlined" onClick={() => setStage(0)}>
          arrow_back
        </span>
        <h2>Fecha de entrega</h2>
      </div>
      <div className="schedule-container">
        <Calendar
          onChange={handleDateChange}
          value={date}
          tileDisabled={isDateDisabled}
        />
      </div>
      <div className="cart-total">
        <button className="common-button" onClick={handleDateConfirmation}>
          Resumen {'>'}
        </button>
      </div>
    </div>
  );
}

export default ScheduleCalendar;
